import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const CustomFields = () => {
  const [fields, setFields] = useState([
    {
      id: 1,
      module: "Employee",
      label: "Preferred Language",
      type: "Select",
      defaultValue: "English",
      required: "Required",
      status: "Active",
    },
    {
      id: 2,
      module: "Projects",
      label: "Project Type",
      type: "Select",
      defaultValue: "Internal",
      required: "Required",
      status: "Active",
    },
  ]);

  const [newField, setNewField] = useState({
    module: "",
    label: "",
    type: "Select",
    defaultValue: "",
    required: "Required",
  });

  const handleChange = (e) => {
    setNewField({ ...newField, [e.target.name]: e.target.value });
  };

  const handleAdd = () => {
    if (!newField.module || !newField.label) return;

    setFields([
      ...fields,
      {
        id: Date.now(),
        ...newField,
        status: "Active",
      },
    ]);

    setNewField({
      module: "",
      label: "",
      type: "Select",
      defaultValue: "",
      required: "Required",
    });
  };

  return (
    <motion.div
      className="card container py-4"
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
    >

      {/* HEADER */}
      <motion.div
        className="d-flex justify-content-between align-items-center mb-4 border-bottom pb-2"
        initial={{ opacity: 0, x: -20 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 0.1 }}
      >
        <motion.h5
          className="fw-semibold mb-3 text-primary"
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.1 }}
        >
          Custom Fields
        </motion.h5>
        <motion.button
          whileTap={{ scale: 0.9 }}
          className="btn btn-dark btn-sm"
          data-bs-toggle="modal"
          data-bs-target="#addFieldModal"
        >
          + Add Fields
        </motion.button>
      </motion.div>
      <div className="container">

        {/* CARD */}
        <motion.div
          className="card shadow-sm border-0 rounded-3"
          initial={{ opacity: 0, scale: 0.97 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.15 }}
        >
          <div className="card-body">

            <h6 className="fw-semibold mb-3">Custom Fields List</h6>

            <div className="table-responsive">
              <table className="table align-middle mb-0">

                <thead className="table-light">
                  <tr className="small">
                    <th><input type="checkbox" /></th>
                    <th>Module</th>
                    <th>Label</th>
                    <th>Type</th>
                    <th>Default Value</th>
                    <th>Required</th>
                    <th>Status</th>
                  </tr>
                </thead>

                <tbody>
                  <AnimatePresence>
                    {fields.map((item, index) => (
                      <motion.tr
                        key={item.id}
                        className="small"
                        initial={{ opacity: 0, y: 15 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -15 }}
                        transition={{ delay: index * 0.05 }}
                        whileHover={{ scale: 1.01 }}
                      >
                        <td><input type="checkbox" /></td>
                        <td>{item.module}</td>
                        <td>{item.label}</td>
                        <td>{item.type}</td>
                        <td>{item.defaultValue}</td>
                        <td>{item.required}</td>

                        <td>
                          <motion.span
                            className="badge bg-success-subtle text-success rounded-pill px-3"
                            initial={{ scale: 0.8 }}
                            animate={{ scale: 1 }}
                          >
                            {item.status}
                          </motion.span>
                        </td>
                      </motion.tr>
                    ))}
                  </AnimatePresence>
                </tbody>

              </table>
            </div>

          </div>
        </motion.div>
      </div>

      {/* MODAL */}
      <div className="modal fade" id="addFieldModal" tabIndex="-1">
        <div className="modal-dialog modal-dialog-centered">
          <motion.div
            className="modal-content"
            initial={{ opacity: 0, scale: 0.9, y: 30 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            transition={{ duration: 0.3 }}
          >
            <div className="modal-header">
              <h6 className="modal-title">Add Custom Field</h6>
              <button className="btn-close" data-bs-dismiss="modal"></button>
            </div>

            <div className="modal-body">

              <input
                className="form-control mb-2"
                placeholder="Module"
                name="module"
                value={newField.module}
                onChange={handleChange}
              />

              <input
                className="form-control mb-2"
                placeholder="Label"
                name="label"
                value={newField.label}
                onChange={handleChange}
              />

              <select
                className="form-select mb-2"
                name="type"
                value={newField.type}
                onChange={handleChange}
              >
                <option>Select</option>
                <option>Text</option>
                <option>Number</option>
              </select>

              <input
                className="form-control mb-2"
                placeholder="Default Value"
                name="defaultValue"
                value={newField.defaultValue}
                onChange={handleChange}
              />

              <select
                className="form-select"
                name="required"
                value={newField.required}
                onChange={handleChange}
              >
                <option>Required</option>
                <option>Optional</option>
                <option>Disabled</option>
              </select>

            </div>

            <div className="modal-footer">
              <motion.button
                whileTap={{ scale: 0.9 }}
                className="btn btn-secondary btn-sm"
                data-bs-dismiss="modal"
              >
                Cancel
              </motion.button>

              <motion.button
                whileTap={{ scale: 0.9 }}
                className="btn btn-primary btn-sm"
                onClick={handleAdd}
                data-bs-dismiss="modal"
              >
                Add
              </motion.button>
            </div>
          </motion.div>
        </div>
      </div>

    </motion.div>
  );
};

export default CustomFields;